document.addEventListener("DOMContentLoaded", () => {

    const form = document.querySelector(".boa-contact form");

    if (!form) return;

    form.addEventListener("submit", (e) => {

        const checkbox = form.querySelector("input[type='checkbox']");

        if (!checkbox.checked) {
            e.preventDefault();
            alert("You must accept the terms.");
        }

    });

});